import {
  USQCPPage,
  UKQCPPage,
  ReferralPage,
  AgentReferralPage,
  QuestionnairePage,
  ShowcasePage,
  PostQuoteQuestionnairePage,
  RecommendationsPage,
  ExplanationPage,
  PhoneNumberPage,
  CombinedPaymentPage,
  QuoteDetailsPage,
  ExpiredPage,
  MtaSummaryPage,
  MtaStartDatePage,
  RfqNotCompatiblePage,
  PolicyNotRenewablePage,
  PolicyAlreadyRenewedPage,
  UKDirectDebitPage,
  UKPaymentConfirmationPage,
  UKStripePaymentPage,
  USPaymentConfirmationPage,
} from "@simplybusiness/mobius-journey";
import DevTools from "../packs/components/DevTools";

export const pageComponents = {
  ReferralPage,
  USQCPPage,
  UKQCPPage,
  AgentReferralPage,
  QuestionnairePage,
  PostQuoteQuestionnairePage,
  ShowcasePage,
  RecommendationsPage,
  ExplanationPage,
  PhoneNumberPage,
  CombinedPaymentPage,
  QuoteDetailsPage,
  ExpiredPage,
  MtaSummaryPage,
  MtaStartDatePage,
  RfqNotCompatiblePage,
  PolicyNotRenewablePage,
  PolicyAlreadyRenewedPage,
  UKDirectDebitPage,
  UKPaymentConfirmationPage,
  UKStripePaymentPage,
  USPaymentConfirmationPage,
};

export const utilityComponents = {
  DevTools,
};
